import { v4 as uuidv4 } from 'uuid';
import { Guid } from './guid';

export const generateGuid = (): Guid => {
  return uuidv4();
};
